import styled from "styled-components";

export const LinkButton = styled.button`
  color: var(--ons-color-text-link);
  text-decoration: underline 1px;
  text-underline-position: under;
  cursor: pointer;
  font-weight: 400;

  &:active,
  &.active {
    top: 0;
  }

  &:hover {
    color: var(--ons-color-text-link-hover);
    text-decoration: underline solid var(--ons-color-text-link-hover) 2px;
  }

  &:focus {
    background-color: var(--ons-color-focus);
    -webkit-box-decoration-break: clone;
    box-decoration-break: clone;
    box-shadow:
      0 -2px var(--ons-color-focus),
      0 4px var(--ons-color-text-link-focus);
    color: var(--ons-color-text-link-focus);
    text-decoration: underline solid transparent 2px;
  }
`;
